import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Badge, Button, Form } from "react-bootstrap";
import { BsStarFill, BsStarHalf, BsFillEyeFill } from "react-icons/bs";
import { Database } from "./Firebase/Firebase"
import { Link } from "react-router-dom";
import {FaShippingFast} from "react-icons/fa"
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import InnerImageZoom from 'react-inner-image-zoom';
import "../layout/ConfirmProduit.css"
import NavBar from "./NavBar"
const ConfirmProduit = () => {
    const [fetch, setFetch] = useState();
    const [quantity, setQuantity] = useState(1);
    useEffect(() => {
        setFetch(JSON.parse(localStorage.getItem('Article')))
    }, [])

    let randomNumbersWatched = Math.floor(Math.random() * 9) + 1;
    /**To Get Random Number Watched Article With You */

   

    /****  Icon Style Star */
    let iconStarStyle = { color: "#C5A207" }
    let iconShippingStyle = {fontSize:21}
    return (
        <>
        <NavBar/>
            <Container className="PopUpParent">
                <Container>
                    <Row>
                        <Col md={5} width="100%">
                            <InnerImageZoom src={fetch ? fetch.urlToUse : null} className="img-fluid" alt="Product" />
                        </Col>
                        <Col md={7} width="100%">
                            <Badge variant="success">New</Badge>
                            <h2 className="NameP">{fetch ? fetch.name : null}</h2>
                            <p className="CodeP">Product Code : {fetch ? fetch.id : null}</p>
                            <div><BsStarFill style={iconStarStyle} /><BsStarFill style={iconStarStyle} /><BsStarFill style={iconStarStyle} /><BsStarFill style={iconStarStyle} /><BsStarHalf style={iconStarStyle} /></div>
                            <p className="Price">{fetch ? (fetch.prix * quantity == 0) ? (fetch.prix) : (fetch.prix * quantity) : null} DH</p>
                            <p> <b className="Marque">{fetch?fetch.size:null}</b> </p>
                            <label className="Quantity">Quantity : </label>
                            <input onChange={(e) => { setQuantity(e.target.value) }} value={quantity} min="1" type="number" name="Quantity" />
                            <Link className="LinkToForm" to="/Confirm_Commande">
                                <Button className="Acheter">لطلب إضغط هنا</Button>
                            </Link>
                            <div className="restParent ">
                                            توصيل مجاني  <FaShippingFast style={iconShippingStyle}/>
                        </div>
                           <div className="restParent ">
                                 سارع!   <span className="rest">7</span> فقط متبقية في مخزن
                        </div>
                            <div className="eyes text-center">
                                يشاهده <Badge className="Watched">{randomNumbersWatched}</Badge> متصفح في الوقت الحالي
                        </div>

                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    )
}

export default ConfirmProduit
